/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".tagslist-grid[_ngcontent-%COMP%]{box-sizing:border-box;max-width:1200px;margin:20px auto 0;float:right;width:95%}.tagListNumbering[_ngcontent-%COMP%]{padding-top:20px;float:left;width:5%}\n/*# sourceMappingURL=tagslist.component.css.map*/"];
export { styles as styles };
